import { render, staticRenderFns } from "./servicios-higiene-editar.vue?vue&type=template&id=6bdefa90&scoped=true&"
import script from "./servicios-higiene-editar.vue?vue&type=script&lang=js&"
export * from "./servicios-higiene-editar.vue?vue&type=script&lang=js&"
import style0 from "./servicios-higiene-editar.vue?vue&type=style&index=0&id=6bdefa90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdefa90",
  null
  
)

export default component.exports